module.exports = __webpack_public_path__ + "static/media/logo.19ce2d35.svg";